import moment from 'moment-timezone';
import { AssignObjectDataByMap } from '../123';

export function GetDataTableMap() {
    const dataTableRowMap = {
        c: [],
        p: null
    }
    dataTableRowMap.c['#itemMap'] = {v: null, f: '', p: null};
    const dataTableMap = {
        cols: [],
        rows: []
    }
    dataTableMap.cols['#itemMap'] = {type: '', id: '', label: '', pattern: '', role: '', p: null};
    dataTableMap.rows['#itemMap'] = dataTableRowMap;

    return dataTableMap;
}

export function NormalizeDataTable(dataTable) {
    const result = {};
    AssignObjectDataByMap(result, dataTable, GetDataTableMap());

    result.cols.forEach((col, ci) => {
        switch (col.type) {
            case 'datetime':
            case 'date':
                result.rows.forEach(row => {
                    if (typeof row.c[ci].v === 'string') {
                        const m = moment.utc(row.c[ci].v);
                        if (m.isValid()) {
                            row.c[ci].v = m.toDate();
                        }
                    }
                });
                break;
            
            case 'datetimeoffset':
            case 'dateoffset':
                col.type = col.type.replace('offset', '');
                const referenceTime = moment.utc(col.p.ReferenceTime);
                const offsetUnit = col.p.OffsetUnit;

                result.rows.forEach(row => {
                    if (typeof row.c[ci].v === 'number') {
                        const m = referenceTime.clone().add(row.c[ci].v, offsetUnit);
                        if (m.isValid()) {
                            row.c[ci].v = m.toDate();
                        }
                    }
                });
                break;
        }
    });

    return result;
}
